<template>
  <details class="card card--collapsible" open>
    <summary class="card__title card__title--bg-primary">
      <h5>{{ descripcionItem }}</h5>
    </summary>
    <div class="card__content">
      <div class="card">
        <div class="card__title">
          <h5>Saldos iniciales</h5>
        </div>
        <div class="card__content">
          <div class="table-responsive">
            <table>
              <thead>
                <tr>
                  <th>Bodega</th>
                  <th>Cantidad</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(saldoInicial, index) in saldosIniciales"
                  :key="index"
                >
                  <td>
                    {{ saldoInicial.descripcion_bodega }}
                  </td>
                  <td>
                    {{ parseInt(saldoInicial.cantidad) }}
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <td>
                    <strong>Total</strong>
                  </td>
                  <td>
                    {{ saldoInicialTotal }}
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card__title">
          <h5>Movimientos</h5>
        </div>
        <div class="card__content">
          <k-table
            :createButton="false"
            :editButton="false"
            :deleteButton="false"
            :filterStatus="false"
            :path="path"
            :params="{
              tipo_fecha: tipo_fecha,
              desde: desde,
              hasta: hasta,
              bodegas_id: bodegas_id,
              item_id: itemId,
            }"
            :columns="[
              {
                display: 'Fecha',
                value: 'movimiento.fecha_transaccion',
              },
              {
                display: 'Tipo',
                value: 'movimiento.tipo_documento',
              },
              {
                display: '# Documento',
                value: 'movimiento.numero_documento',
              },
              {
                display: 'Bodega',
                value: 'movimiento.descripcion_bodega'
              },
              {
                display: 'Cantidad',
                value: 'cantidad',
                numeric: true,
              },
              {
                display: 'Observación',
                value: 'observacion',
              },
            ]"
          ></k-table>
        </div>
      </div>
      <div class="card mt-2">
        <div class="card__title">
          <h5>Saldos finales</h5>
        </div>
        <div class="card__content">
          <div class="table-responsive">
            <table>
              <thead>
                <tr>
                  <th>Bodega</th>
                  <th>Cantidad</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(saldoFinal, index) in saldosFinales" :key="index">
                  <td>
                    {{ saldoFinal.descripcion_bodega }}
                  </td>
                  <td>
                    {{ parseInt(saldoFinal.cantidad) }}
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <td>
                    <strong>Total</strong>
                  </td>
                  <td>
                    {{ saldoFinalTotal }}
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
    </div>
  </details>
</template>

<script>
export default {
  computed: {
    saldoFinalTotal: function () {
      let saldoFinalTotal = 0;
      for (let i = 0; i < this.saldosFinales.length; i++) {
        saldoFinalTotal += parseInt(this.saldosFinales[i].cantidad);
      }
      return saldoFinalTotal;
    },
    saldoInicialTotal: function () {
      let saldoInicialTotal = 0;
      for (let i = 0; i < this.saldosIniciales.length; i++) {
        saldoInicialTotal += parseInt(this.saldosIniciales[i].cantidad);
      }
      return saldoInicialTotal;
    },
  },
  props: {
    itemId: {
      type: String,
      required: false,
      default: "",
    },
    descripcionItem: {
      type: String,
      required: false,
      default: "",
    },
    saldosIniciales: {
      type: Array,
      required: false,
      default: function () {
        return [];
      },
    },
    saldosFinales: {
      type: Array,
      required: false,
      default: function () {
        return [];
      },
    },
    tipo_fecha: {
      type: String,
      required: true,
    },
    desde: {
      type: String,
      required: false,
    },
    hasta: {
      type: String,
      required: false,
    },
    bodegas_id: {
      type: Array,
      required: false,
    },
  },
  data: function () {
    return {
      path: url + "/kardex/movimientos",
    };
  },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/inventario/ItemKardex.vue